import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content"
}
const _hoisted_2 = {
  id: "update-address-form",
  class: "form update-address gap-0",
  method: "post"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "fs-base w-100 fw-semibold pdb-10" }, "Member ID ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "fs-base w-100 fw-semibold pdb-10 pdt-20" }, "Member Name ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "fs-base w-100 fw-semibold pdb-10 pdt-20" }, "Most Recent Employer/ Production ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "fs-base w-100 fw-semibold pdb-10 pdt-30" }, "Addresses ", -1)
const _hoisted_7 = { class: "action-buttons pdt-40" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MessageCard, {
      message: "Please provide the information by correcting/adding data and clicking on the “Save” button.",
      type: "primary",
      iconClass: "iatse-icon-alarm",
      classes: "info_card_full"
    }),
    _createVNode(_component_Alerts, {
      success: _ctx.success,
      info: _ctx.info,
      errors: _ctx.errors?.General
    }, null, 8, ["success", "info", "errors"]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_ctx.formData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("form", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_TextInput, {
                type: "text",
                label: "NBF ID ",
                placeholder: "Enter Address 1",
                max: 30,
                modelValue: _ctx.formData.PersonID,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.PersonID) = $event)),
                readonly: true,
                error: _ctx.inputErrors.PersonID
              }, null, 8, ["modelValue", "error"]),
              _hoisted_4,
              _createVNode(_component_TextInput, {
                type: "text",
                label: "First Name ",
                placeholder: "Enter Address 1",
                max: 30,
                modelValue: _ctx.formData.FirstName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.FirstName) = $event)),
                readonly: true,
                error: _ctx.inputErrors.FirstName
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_TextInput, {
                type: "text",
                label: "Last Name",
                placeholder: "Enter Address 1",
                max: 30,
                modelValue: _ctx.formData.LastName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.LastName) = $event)),
                readonly: true,
                error: _ctx.inputErrors.LastName
              }, null, 8, ["modelValue", "error"]),
              _hoisted_5,
              _createVNode(_component_TextInput, {
                type: "text",
                placeholder: "Enter Last Production",
                max: 100,
                modelValue: _ctx.formData.Employer,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.Employer) = $event)),
                readonly: true,
                error: _ctx.inputErrors.Employer,
                customClass: "h-fit gap-0 pdb-20"
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_TextInput, {
                type: "text",
                placeholder: "Enter Last Production",
                max: 100,
                modelValue: _ctx.formData.Production,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.Production) = $event)),
                readonly: true,
                error: _ctx.inputErrors.Production,
                customClass: "h-fit gap-0 pdb-20"
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_DateInput, {
                label: "Date Of Birth",
                max: 30,
                modelValue: _ctx.formData.DateofBirth,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.DateofBirth) = $event)),
                error: _ctx.inputErrors.DateofBirth
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_SelectComponent, {
                label: "Gender",
                selectedOption: _ctx.formData.Sex,
                "onUpdate:selectedOption": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.Sex) = $event)),
                options: _ctx.profileStore.genders,
                singleArrow: true,
                error: _ctx.inputErrors.Gender
              }, null, 8, ["selectedOption", "options", "error"]),
              _hoisted_6,
              _createVNode(_component_TextInput, {
                type: "text",
                label: "Address Line 1 ",
                placeholder: "Enter Address 1",
                max: 30,
                modelValue: _ctx.formData.Street1,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.Street1) = $event)),
                required: true,
                "is-required": true,
                error: _ctx.errors.Street1,
                customClass: "pdb-20",
                name: "mixed"
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_TextInput, {
                type: "text",
                label: "Address Line 2",
                placeholder: "Enter Address 2",
                max: 30,
                modelValue: _ctx.formData.Street2,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.Street2) = $event)),
                required: true,
                customClass: "pdb-20",
                name: "mixed"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_TextInput, {
                type: "text",
                label: "City",
                placeholder: "Enter City",
                max: 25,
                modelValue: _ctx.formData.City,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.City) = $event)),
                required: true,
                "is-required": true,
                error: _ctx.errors.City,
                customClass: "pdb-20",
                name: "mixed"
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_SelectComponent, {
                label: "State/Province",
                selectedOption: _ctx.formData.State,
                "onUpdate:selectedOption": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.State) = $event)),
                options: _ctx.filteredStates,
                "single-arrow": true,
                "is-required": true,
                error: _ctx.errors.State,
                customClass: "pdb-20"
              }, null, 8, ["selectedOption", "options", "error"]),
              _createVNode(_component_SelectComponent, {
                label: "Country",
                selectedOption: _ctx.formData.Country,
                "onUpdate:selectedOption": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.Country) = $event)),
                options: _ctx.countries,
                "single-arrow": true,
                "is-required": true,
                error: _ctx.errors.Country
              }, null, 8, ["selectedOption", "options", "error"]),
              _createVNode(_component_TextInput, {
                type: "text",
                label: "Postal Code",
                placeholder: "Enter Postal Code",
                max: 9,
                modelValue: _ctx.formData.ZipCode,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.ZipCode) = $event)),
                name: "number",
                required: true,
                "is-required": true,
                error: _ctx.errors.ZipCode
              }, null, 8, ["modelValue", "error"]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.discardChanges && _ctx.discardChanges(...args)), ["prevent"])),
                  class: "btn btn-secondary",
                  disabled: _ctx.loadingSubmit
                }, " Discard", 8, _hoisted_8),
                _createElementVNode("button", {
                  onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
                  class: "btn btn-primary",
                  disabled: _ctx.loadingSubmit
                }, _toDisplayString(_ctx.loadingSubmit ? 'Saving...' : 'Save'), 9, _hoisted_9)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
  ], 64))
}